import { render, staticRenderFns } from "./qianbao01_list.vue?vue&type=template&id=2c87f4cb&scoped=true"
import script from "./qianbao01_list.vue?vue&type=script&lang=js"
export * from "./qianbao01_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c87f4cb",
  null
  
)

export default component.exports